export const LandingRoute = '/u/landing';
export const LandingRoutePath = 'u/landing';

export * from './u-general.m';
export * from './logged-out.comp';
